module.exports = __webpack_public_path__ + "img/help-content-7.2e7601d9.png";